import React from "react";
import {ErrorMessage} from "formik";
import RadioComponent from "../../../../../common/Radio";
import InputComponent from "../../../../../common/Input";
import {Trans} from "react-i18next";

export default function CyberAssuranceProtection2({translation, isTcs}) {
    return (
        <>
            <div className={'item'}>
                <h4>
                    {translation("step2Label")}
                </h4>
            </div>

            <div className={'item'}>
                <InputComponent data={{name: 'assistaInsurer', label: translation('insurerLabel')}}/>
            </div>

            {isTcs &&
                <p>
                    <Trans i18nKey="ASSISTA_Generic_Form_Step2_Text_TCS">message<a target="_blank" rel="noopener noreferrer"
                                                                                   href={translation('ASSISTA_Generic_Form_Step2_Text_TCS_Link')}>link</a></Trans>
                </p>
            }

            {!isTcs &&
                <>
                    <div className={'item'}>
                        <InputComponent data={{name: 'assistaPoliceNumber', label: translation('policeNumberLabel') + '*'}}/>
                    </div>

                    <div className={'item'}>
                        <label className={'form-label'}>
                            {translation('genderLabel') + '*'}
                        </label>
                        <RadioComponent
                            data={{id: 'assistaGender1', value: 'male', name: 'assistaGender', label: translation('genderMaleLabel')}}/>
                        <RadioComponent
                            data={{id: 'assistaGender2', value: 'female', name: 'assistaGender', label: translation('genderFemaleLabel')}}/>
                        <RadioComponent
                            data={{id: 'assistaGender3', value: 'other', name: 'assistaGender', label: translation('genderOtherLabel')}}/>
                        <ErrorMessage className="text-danger" name='assistaGender' component="div" />
                    </div>

                    <div className={'item-names'}>
                        <InputComponent
                            data={{
                                name: 'assistaFirstname',
                                label: translation('firstnameLabel') + '*',
                                autoComplete: "given-name",
                                inputMode: "text"
                            }}
                        />
                        <InputComponent
                            data={{
                                name: 'assistaSurname',
                                label: translation('surnameLabel') + '*',
                                autoComplete: "family-name",
                                inputMode: "text"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaCompanyName',
                                label: translation('companyNameLabel'),
                                inputMode: "text"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaBirthday',
                                label: translation('birthdayLabel'),
                                autoComplete: "bday",
                                type: "date"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaAddress',
                                label: translation('addressLabel') + '*',
                                autoComplete: "street-address",
                                inputMode: "text",
                                component: "textarea",
                                rows: "3"
                            }}
                        />
                    </div>

                    <div className={'item-street'}>
                        <InputComponent
                            data={{
                                name: 'assistaAddressNPA',
                                label: translation('npaLabel') + '*',
                                autoComplete: "postal-code",
                                inputMode: "numeric"
                            }}
                        />
                        <InputComponent
                            data={{
                                name: 'assistaAddressCity',
                                label: translation('cityLabel') + '*',
                                autoComplete: "address-level2",
                                className: "city",
                                inputMode: "text"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaLand',
                                label: translation('landLabel') + '*',
                                autoComplete: "country-name",
                                inputMode: "text"
                            }}
                        />
                    </div>


                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaPhone',
                                label: translation('phoneNumberLabel') + '*',
                                autoComplete: "tel",
                                inputMode: "tel"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaPhoneBis',
                                label: translation('phoneNumberBisLabel'),
                                inputMode: "tel"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaEmail',
                                label: translation('emailLabel') + '*',
                                autoComplete: "email",
                                inputMode: "email"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <h5>
                            {translation('holderInformationLabel')}
                        </h5>
                    </div>

                    <div className={'item'}>
                        <label className={'form-label'}>
                            {translation('genderLabel')}
                        </label>
                        <RadioComponent
                            data={{id: 'assistaHolderGender1', value: 'male', name: 'assistaHolderGender', label: translation('genderMaleLabel')}}/>
                        <RadioComponent
                            data={{id: 'assistaHolderGender2', value: 'female', name: 'assistaHolderGender', label: translation('genderFemaleLabel')}}/>
                        <RadioComponent
                            data={{id: 'assistaHolderGender3', value: 'other', name: 'assistaHolderGender', label: translation('genderOtherLabel')}}/>
                        <ErrorMessage className="text-danger" name='assistaHolderGender' component="div" />
                    </div>

                    <div className={'item-names'}>
                        <InputComponent
                            data={{
                                name: 'assistaHolderFirstname',
                                label: translation('firstnameLabel'),
                                inputMode: "text"
                            }}
                        />
                        <InputComponent
                            data={{
                                name: 'assistaHolderSurname',
                                label: translation('surnameLabel'),
                                inputMode: "text"
                            }}
                        />
                    </div>

                    <div className={'item'}>
                        <InputComponent
                            data={{
                                name: 'assistaHolderCompany',
                                label: translation('holderLabel'),
                                inputMode: "text"
                            }}
                        />
                    </div>
                </>
            }
        </>
    )
}